import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { ModalShell } from '@quizzach/components';

const InfoBody = styled.div`
	font-size: 16px;
	line-height: 1.55;

	p {
		margin: 0 0 14px;
	}

	p:last-child {
		margin-bottom: 0;
	}
`;

/* »saznaj više« on the /play TV row: what the TV app is, where to get it
   and how the pairing code behaves. */
export const TvAppInfoModal = ({
	show,
	closeModal,
}: {
	show: boolean;
	closeModal: () => void;
}) => {
	const { t } = useTranslation();

	return (
		<ModalShell
			show={show}
			onClose={closeModal}
			size='md'
			label={t('modal.tvAppInfo.label')}
			title={t('modal.tvAppInfo.title')}
		>
			<InfoBody>
				<p>{t('modal.tvAppInfo.p1')}</p>
				<p>{t('modal.tvAppInfo.p2')}</p>
				<p>{t('modal.tvAppInfo.p3')}</p>
			</InfoBody>
		</ModalShell>
	);
};
